import {ISearchService} from '../../types';
import HandleSearch from './methods/HandleSearch';
import GetFilters from './methods/GetFilters';
import GetProductResults from './methods/GetProductResults';
import GetCmsContent from './methods/GetCmsContent';

const BoostCommerce: ISearchService = {
  methods: {
    handleSearch: HandleSearch,
    getFilters: GetFilters,
    getProductResults: GetProductResults,
    getCmsContent: GetCmsContent
  }
}

export default BoostCommerce